import Collapse from 'app/components/base/Collapse'
import Link from 'app/components/base/Link'
import Skeleton from 'app/components/base/Skeleton'
import Stack from 'app/components/base/Stack'

interface HelpCenterCollapseCardProps {
  categoryName: string
  isActiveCategory: boolean
  subcategorySlug?: string
  subcategories?: HelpCenterCategoryModel[]
  hideBorderBottom?: boolean
  isLoading?: boolean
}

const HelpCenterCollapseCard = ({
  categoryName,
  isActiveCategory,
  subcategorySlug,
  subcategories,
  hideBorderBottom,
  isLoading
}: HelpCenterCollapseCardProps) => {
  return (
    <Skeleton loading={isLoading} sx={{ width: '100%', height: 52 }}>
      <Collapse
        open={isActiveCategory}
        title={categoryName}
        titleSx={{
          ...(!isActiveCategory && {
            color: 'text.third'
          })
        }}
        titleContainerSx={{ py: 2 }}
        sx={{
          width: '100%',
          borderBottomWidth: { xs: hideBorderBottom ? 0 : 1, md: 1 },
          borderBottomStyle: 'solid',
          borderColor: 'stroke.main'
        }}
      >
        <Stack direction="column" spacing={1} sx={{ pb: 2 }}>
          {subcategories?.map((item) => {
            const isActive = item.slug === subcategorySlug
            const link = `/help-centre/${item.slug}`

            return (
              <Link
                key={item.id}
                variant="subtitle1"
                href={link}
                lineClamp={1}
                sx={{
                  color: 'text.third',
                  ...(isActive && {
                    color: 'primary.main',
                    fontWeight: 500
                  })
                }}
              >
                {item.name}
              </Link>
            )
          })}
        </Stack>
      </Collapse>
    </Skeleton>
  )
}

export default HelpCenterCollapseCard
